import { yellow, teal } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: teal[500]
    },
    secondary: {
      main: yellow[100]
    }
  },
  typography: {
    fontFamily: `BlinkMacSystemFont,-apple-system,Roboto,Ubuntu,Segoe UI,"Helvetica Neue",Helvetica,Arial,sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500
  }
});
